// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3LU1s","requiredAsterisk":"Info_requiredAsterisk__3gmLL"};